import React, { useEffect, useState } from 'react'
import {
  DomainSelectionContainer,
  FooterContainer,
  HoriontalSpacerWithBorder,
  MessageContainer,
  MethodSelectionContainer,
  SetupDomainsWrapper,
} from './Steps.styled'
import {
  ButtonWithIcon,
  GeneralSelect,
  StyledText,
  Toast,
} from '@clickcease/cc-client-components-lib'
import { DomainToSelect } from '../CrossSaleModal.types'
import { useTranslation } from 'react-i18next'
import { BzSetupInner } from 'Features/bzSetupPopup/BzSetupInner'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons'
import { GetTagInner } from 'Features/domainsManagement/components/GetTagModal/GetTagInner'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { useNavigate } from 'react-router-dom'
import { useSplit } from 'Hooks/useSplit'
import { ImplementTag } from 'Features/OnboardingWizard/components/ImplementTag/ImplementTag'

interface SetupDomainsProps {
  domains: DomainToSelect[]
  isBotMitigation: boolean
  onDone: () => void
}

const NEW_TAG_IMPLEMENTATION = 'CE_CROSSSALE_TAG_MODAL_0324'

export const SetupDomains = ({ onDone, isBotMitigation, domains }: SetupDomainsProps) => {
  const { t } = useTranslation('general')
  const showNewTagImplementation = useSplit(NEW_TAG_IMPLEMENTATION)
  const navigate = useNavigate()
  const [currentDomain, setCurrentDomain] = useState<DomainToSelect | null>(domains[0])
  const moreThanOneDomain = domains.length > 1
  const showRemoveTagMessage =
    isBotMitigation &&
    currentDomain &&
    currentDomain.wordpress &&
    !currentDomain.botZappingPluginActivated &&
    (currentDomain.paidMarketingConnected || currentDomain.botZappingConnected)
  const currentDomainIndex = domains.findIndex((domain) => domain.id === currentDomain?.id)

  const onNextDomain = () => {
    if (currentDomainIndex === domains.length - 1) {
      setCurrentDomain(domains[0])
    } else {
      setCurrentDomain(domains[currentDomainIndex + 1])
    }
  }

  useEffect(() => {
    if (domains.length === 0) {
      navigate(`/domain-management`)
    }
  }, [domains, navigate])

  const renderOldTagImplementation = () => {
    return currentDomain?.wordpress ? (
      <BzSetupInner
        domainAddress={currentDomain ? currentDomain.address : ''}
        onOpenChange={() => {}}
        isContentOnly
      />
    ) : (
      <GetTagInner
        domain={undefined}
        tagUrl={currentDomain?.tagUrl || ''}
        onOpenChange={() => {}}
        domainId={currentDomain?.id || 0}
        domainAddress={currentDomain?.address}
      />
    )
  }

  return (
    <SetupDomainsWrapper>
      <MessageContainer isNewTagImplementation={showNewTagImplementation}>
        {showRemoveTagMessage && (
          <Toast type={'failure'}>
            <StyledText variant={'baseLight'}>{t('crossSaleModal.removeTagMessage')}</StyledText>
          </Toast>
        )}
      </MessageContainer>
      {showNewTagImplementation ? (
        <MethodSelectionContainer>
          <ImplementTag
            addedDomainAddress={currentDomain ? currentDomain.address : ''}
            preSelectedMethod={currentDomain?.wordpress ? 'wordpressPlugin' : 'googleTagManager'}
            noFooter
            smallIcons
            onFinish={() => {}}
            onBack={() => {}}
            key={currentDomain?.id}
            containerCss={{ minHeight: '523px' }}
            customComponent={
              <>
                <HoriontalSpacerWithBorder />
                <DomainSelectionContainer isNewTagImplementation={showNewTagImplementation}>
                  <StyledText variant={'baseBold'}>{t('crossSaleModal.domainsLabel')}</StyledText>
                  <GeneralSelect
                    options={domains}
                    value={currentDomain}
                    onChange={setCurrentDomain}
                    getOptionValue={(option: DomainToSelect) => option.id.toString()}
                    getOptionLabel={(option: DomainToSelect) => option.address}
                    wrapperCSS={{ width: '300px' }}
                  />
                </DomainSelectionContainer>
              </>
            }
          />
        </MethodSelectionContainer>
      ) : (
        renderOldTagImplementation()
      )}
      <FooterContainer isTwoIcons={moreThanOneDomain}>
        {moreThanOneDomain && (
          <ButtonWithIcon
            variant={'ghost'}
            text={t('crossSaleModal.setUpNext')}
            iconRight={<FontAwesomeIcon icon={faAngleRight as IconProp} />}
            onClick={onNextDomain}
          />
        )}
        <ButtonWithIcon onClick={onDone} text={t('crossSaleModal.finish')} />
      </FooterContainer>
    </SetupDomainsWrapper>
  )
}
